import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import RmvendorquotationEditFormImpl from './RmvendorquotationEditFormImpl';
import RmvendorquotationList from './RmvendorquotationList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import RmvendorquotationListView from './RmvendorquotationListView'


export default function RmvendorquotationDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.rmvendorquotationDashboard);
  const [ rmvendorquotationId, setRmvendorquotationId] = React.useState('');
  const [reloadRmvendorquotationList, setReloadRmvendorquotationList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <RmvendorquotationEditFormImpl 
            setReloadRmvendorquotationList={setReloadRmvendorquotationList}
            rmvendorquotationId={rmvendorquotationId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <RmvendorquotationListView 
                      setRmvendorquotationId = {setRmvendorquotationId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
